import { Component, Inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { PincodeTransmissionService } from '../../../../../services/raintree/Transmission/pincode.service';
import { error } from 'console';
import { ToastrService } from 'ngx-toastr';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-deposit-report-filter',
  standalone: true,
  imports: [ReactiveFormsModule, MatSelectModule, MatIconModule, MatDialogModule, CommonModule],
  templateUrl: './deposit-report-filter.component.html',
  styleUrl: './deposit-report-filter.component.scss'
})
export class DepositReportFilterComponent {
  constructor(
    private dialogRef: MatDialogRef<DepositReportFilterComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private pincodeService: PincodeTransmissionService,
    private toaster: ToastrService


  ) { }

  roleTypes: any[] = []

  pin = new FormControl('');
  state = new FormControl('');
  district = new FormControl('');
  roleList: any[] = []
  stateList: any = [];
  districtList: any = [];
  pincodeList: any = [];

  ngOnInit(): void {
    this.state.setValue(this.data.state);
    this.district.setValue(this.data.district);
    this.pin.setValue(this.data.pin);
  }

  onStateSelect(state: any) {
    this.state.setValue(state.value)
    this.districtList = Object.keys(this.pincodeList?.[state.value])
    if (this.districtList.length == 1) {
      this.district.setValue(this.districtList[0])
    }
  }

  onDistrictSelect(district: any) {
    this.district.setValue(district.value)
  }

  onClearClick() {
    this.pin.reset()
    this.state.reset()
    this.district.reset()
  }

  onSearchClick() {
    this.dialogRef.close({
      pin: this.pin.value,
      state: this.state.value,
      district: this.district.value
    })
  }


  getStateDistrict(pin: string) {
    this.pincodeService.getStateDistrictV2(pin).subscribe({
      next: (res) => {
        this.pincodeList = res.data
        this.stateList = Object.keys(this.pincodeList)
        console.log(this.stateList, 'state');

        if (this.stateList.length == 1) {
          this.state.setValue(this.stateList[0]);
          this.districtList = Object.keys(this.pincodeList?.[this.stateList[0]] || {})
          if (this.districtList.length == 1) {
            this.district.setValue(this.districtList[0]);
          }
        }
      },
      error: (error) => {
        this.toaster.error(error.message)
      }
    })
  }

  getPincode(event: any) {
    const value = (event.target as HTMLInputElement).value
    if (value?.length == 6) {
      this.getStateDistrict(value)
    }
  }
}
